export const UNKNOWN = 'UNKNOWN';
export const OUTBOUND = 'OUTBOUND';
export const HEARTBEAT = 'HEARTBEAT';
export const MODIFIER = 'MODIFIER';
